<div class="news-detail">
  <div id="scrollable-area" class="scrollable-area" (scroll)="onScroll($event)">
    <div class="detail-img-content" [ngStyle]="{ 'background-image': 'url(' + urlImg + ')'}" *ngIf="urlImg"></div>
    <div class="card-title-content">
      <div class="title-header">
        <div class="row m-0">
          <div class="col-6 news-agency">
            <img class="img-compamy" src="{{ newWF.img }}">
            <span>{{ newWF.agencyDescription }}</span>
          </div>
          <div class="col-6 news-date">
            <span>{{ newWF.newsDate | date: 'dd \'DE\' MMMM yyyy - HH:mm:ss'| uppercase}}</span>
          </div>
          <div class="col-12 col-hr">
            <hr>
          </div>
          <div class="col-11 col-title">
            <span>{{ newWF.title }}</span>
          </div>
        </div>
        <button class="goback-button" (click)="closeDetails()" *ngIf="close">
          <mat-icon svgIcon="goback"></mat-icon>
          <span class="button-text2">Voltar</span>
        </button>
      </div>
    </div>
    <div id="div-detail" class="div-detail">
      <pre [innerHTML]="newWF.description"></pre>
    </div>
  </div>
  <button id="btn-scroll" class="btn-scroll btn-hidden" (click)="scrollTop()">
    <mat-icon>expand_less</mat-icon>
  </button>
</div>
